const SHOW_TOAST = 'SHOW_TOAST';
const REMOVE_TOAST = 'REMOVE_TOAST';
const CLEAR_TOASTS = 'CLEAR_TOASTS';

const initialState = {
	items: [],
};

export const showToast =
	(options = {}) =>
	(dispatch, getState) => {
		let state = getState();
		let items = [...state.toast.items];

		const toastId = Math.random();
		items.push({
			id: toastId,
			...options,
		});

		// Auto-dismiss toast after 5 seconds (unless autoDismiss is explicitly false)
		if (options.autoDismiss !== false) {
			setTimeout(() => {
				dispatch(closeToast(toastId));
			}, options.duration || 5000);
		}

		return dispatch({
			type: SHOW_TOAST,
			payload: {
				items,
			},
		});
	};

export const clearToasts = () => ({
	type: CLEAR_TOASTS,
	payload: {
		items: [],
	},
});

export const closeToast = (id) => (dispatch, getState) => {
	let state = getState();
	let items = [...state.toast.items];

	items = items.filter((item) => {
		return item.id !== id;
	});

	return dispatch({
		type: REMOVE_TOAST,
		payload: {
			items,
		},
	});
};

const toastReducer = (state = initialState, action) => {
	switch (action.type) {
		case SHOW_TOAST:
		case REMOVE_TOAST:
		case CLEAR_TOASTS:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default toastReducer;
